import initialState from '../store/initial-state'
import {
  JOBS_ADD,
  JOBS_REMOVE,
  JOBS_EMPTY
} from '../constants/job-types'

export default (state = initialState.jobs, action) => {
  switch (action.type) {

    case JOBS_ADD:
      return {
        data: [
          ...state.data,
          action.payload
        ]
      }

    case JOBS_REMOVE:
      return {
        data: [...state.data].filter(r => r._id !== action.payload)
      }

    case JOBS_EMPTY:
      return {
        data: []
      }

    default: return { ...state }
  }
}